import { BaseRouteService } from "./BaseRouteService";

export class InventoryService extends BaseRouteService {
    /**
     * @returns The Mighty Inventory Array!
     */
    public async getInventory(): Promise<string[]> {
        return this.getJsonApi<string[]>("game/inventory");
    }
}
